import { request } from '../../request';

interface IRefreshToken {
  fingerprint: string
}

export const refreshToken = (data: IRefreshToken) => {
	return request({ url: '/user/refresh', method: 'POST', data, retryOnError: true });
};
